const GallerySection = () => {
  const gallery = [
    {
      image: 'https://public.readdy.ai/ai/img_res/a739c7743c0405ca7a35d5337aac36b3.jpg',
      title: 'Custom Suits',
      category: 'Bespoke Tailoring',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=crisp%20white%20custom%20dress%20shirt%20with%20monogram%20cuff%20details%20and%20collar%20stays%20on%20wooden%20hanger%20in%20elegant%20showroom%20with%20soft%20natural%20lighting%20and%20clean%20minimal%20background&width=600&height=800&seq=gallery-shirts-002&orientation=portrait',
      title: 'Dress Shirts',
      category: 'Custom Shirts',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=sophisticated%20navy%20blazer%20sport%20coat%20hanging%20on%20display%20showing%20fine%20wool%20texture%20lapel%20details%20and%20premium%20buttons%20in%20luxury%20tailoring%20studio%20with%20soft%20lighting%20and%20simple%20background&width=600&height=800&seq=gallery-blazers-003&orientation=portrait',
      title: 'Blazers',
      category: 'Sport Coats',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=close%20up%20view%20of%20premium%20suit%20fabric%20swatches%20and%20textile%20samples%20in%20various%20colors%20and%20patterns%20arranged%20on%20wooden%20table%20in%20tailoring%20studio%20showing%20wool%20cashmere%20and%20linen%20textures&width=600&height=800&seq=gallery-fabrics-004&orientation=portrait',
      title: 'Fabric Selection',
      category: 'Premium Materials',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=professional%20tailor%20measuring%20and%20fitting%20custom%20suit%20on%20client%20in%20elegant%20showroom%20workspace%20with%20measuring%20tape%20and%20fabric%20samples%20showing%20craftsmanship%20and%20attention%20to%20detail%20in%20natural%20lighting&width=600&height=800&seq=gallery-process-005&orientation=portrait',
      title: 'Tailoring Process',
      category: 'Craftsmanship',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=skilled%20tailor%20working%20on%20final%20fitting%20adjustments%20of%20custom%20suit%20jacket%20with%20pins%20and%20measuring%20tools%20in%20professional%20tailoring%20workshop%20showing%20expert%20craftsmanship%20and%20precision%20work&width=600&height=800&seq=gallery-fitting-006&orientation=portrait',
      title: 'Final Fitting',
      category: 'Perfect Fit',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Work
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our portfolio of custom tailored garments and see the quality craftsmanship that sets us apart
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {gallery.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-80">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              </div>

              {/* Overlay Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform">
                <div className="text-[#C4A962] text-sm font-semibold mb-2">{item.category}</div>
                <h3 className="text-white text-xl font-bold">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;